
import { supabase } from '@/integrations/supabase/client';
import { HotelData } from '@/lib/types/auth';

export const getHotelData = async (): Promise<HotelData | null> => {
  const { data: user } = await supabase.auth.getUser();
  
  if (!user.user) return null;
  
  const { data, error } = await supabase
    .from('hotels')
    .select('*')
    .eq('id', user.user.id)
    .single();
  
  if (error) {
    console.error('Error fetching hotel data:', error);
    return null;
  }
  
  return {
    id: data.id,
    name: data.name,
    check_in_time: data.check_in_time,
    check_out_time: data.check_out_time,
    services: Array.isArray(data.services) ? data.services as string[] : [],
    faqs: Array.isArray(data.faqs) ? data.faqs as Array<{id: string; question: string; answer: string}> : [],
    contact_email: data.contact_email,
    contact_phone: data.contact_phone,
    address: data.address,
    website: data.website,
    fact_sheet_text: data.fact_sheet_text
  };
};

export const updateHotelData = async (hotelData: HotelData): Promise<{ success: boolean; error?: any }> => {
  const { data: user } = await supabase.auth.getUser();
  
  if (!user.user) return { success: false, error: 'User not authenticated' };
  
  const { error } = await supabase
    .from('hotels')
    .update({
      name: hotelData.name,
      check_in_time: hotelData.check_in_time,
      check_out_time: hotelData.check_out_time,
      services: hotelData.services,
      faqs: hotelData.faqs,
      contact_email: hotelData.contact_email,
      contact_phone: hotelData.contact_phone,
      address: hotelData.address,
      website: hotelData.website,
      fact_sheet_text: hotelData.fact_sheet_text,
      updated_at: new Date().toISOString()
    })
    .eq('id', user.user.id);
  
  if (error) {
    console.error('Error updating hotel data:', error);
    return { success: false, error };
  }
  
  return { success: true };
};
